<template>
  <div>
    <aha-icon-button
      @click="onClickAIChatbotImportButton"
      @keydown.enter="onClickAIChatbotImportButton"
      @keydown.space="onClickAIChatbotImportButton"
      v-aha-emit-action
      name="new-blank-presentation-editor-import-button"
      class="import-button-v3"
      :variant="'tertiary'"
      tabindex="0"
      role="button"
      :disabled="isButtonDisabled"
      v-tooltip="$i18nPresenter.t('Import')"
    >
      <aha-icon
        v-if="!isUploadingOrImportingSlides"
        name="upload-simple"
        width="16"
        height="16"
        viewBox="0 0 32 32"
        maintainColor
        class="import-button-icon"
      />
      <aha-spinner v-if="isUploadingOrImportingSlides" />
    </aha-icon-button>
    <aha-toggle-tip v-if="tooltipProps" v-bind="tooltipProps" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadingTooltipMixin from '@/mixins/UploadingTooltipMixin'

export default {
  name: 'ImportButtonV3',

  mixins: [UploadingTooltipMixin],

  props: {
    isSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // tooltipProps and tooltipCallId will be merged from mixin
      tooltipPlacement: 'right-top',
      tooltipTarget: 'new-blank-presentation-editor-import-button',
    }
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', [
      'isCurrentPresentationImportingSlides',
      'isUploadingOrImportingSlides',
    ]),

    isButtonDisabled() {
      return this.isSelectMode && this.isCurrentPresentationImportingSlides
    },
  },

  methods: {
    ...mapActions('aiChatbotImportPptxPdf', ['setIsAIChatbotImportModalVisibleV2Action']),

    onClickAIChatbotImportButton() {
      if (this.isCurrentPresentationImportingSlides) {
        return
      }
      this.setIsAIChatbotImportModalVisibleV2Action(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.import-button-v3 {
  svg.import-button-icon:not(:hover) {
    &:deep(path) {
      stroke: var(--color-gray-90, #4A4A4A);
    }
  }
  &:hover {
    svg.import-button-icon {
      &:deep(path) {
        stroke: var(--color-primary, #6A1EBB);
      }
    }
  }
}
</style>
